import { Text } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardServicesStore } from 'src/models/useDashboardServicesModel';
import { generateRedirectUrlToLog } from 'src/pages/Log/shared';
import { LogTypeEnum, SecurityFilterName } from '@Types/log';

import { getServiceNamesByValues } from 'src/utils/service';
import { formatTableCounts } from 'src/utils/table';

import { ThreatType } from '../../../../utils/enums';
import Percent from '../../Charts/Percent';
import TableTemplate from '../../Charts/TableTemplate';
import DashboardCard from '../../Layout/DashboardCard';
import RedirectLink from '@Components/RedirectLink';

function SecurityRiskWebReputation(props: { data: any; day: string }) {
  const { t } = useTranslation();
  const servicesModel = useDashboardServicesStore();

  const config = [
    { width: '20%', grow: 2, align: 'left', tooltip: true },
    { width: '12%', grow: 1, align: 'right' },
    { width: '12%', grow: 1, align: 'right' },
    { width: '10%', grow: 1, align: 'right' },
  ];
  const header = [
    t('dashboard.chart.column.criteria'),
    t(`dashboard.chart.column.last${props.day}`),
    t(`dashboard.chart.column.prev${props.day}`),
    t('dashboard.chart.column.change'),
  ];

  const calculateSum = function (json: any) {
    let _sum = 0;
    for (const obj in json) {
      _sum += json[obj].total || 0;
    }
    return _sum;
  };
  const totalDetections = t(
    'dashboard.chart.atpPhishingDetection.totalScanned'
  );
  const detections = t('dashboard.chart.atpPhishingDetection.detection');
  const securityRiskScanDetectedBy: any = {};
  const securityRiskScanDetectedByPrevious: any = {};
  securityRiskScanDetectedBy[`${totalDetections}`] = calculateSum(
    props.data?.summaryTotalItemsScanned?.[props.day]
  );
  securityRiskScanDetectedBy[`${detections}`] = calculateSum(
    props.data?.security_risk_scanWebReputationSummary?.[props.day]
  );

  securityRiskScanDetectedByPrevious[`${totalDetections}`] = calculateSum(
    props.data?.summaryTotalItemsScannedPrevious?.[props.day]
  );
  securityRiskScanDetectedByPrevious[`${detections}`] = calculateSum(
    props.data?.security_risk_scanWebReputationSummaryPrevious?.[props.day]
  );

  const data = formatTableCounts(
    securityRiskScanDetectedBy,
    securityRiskScanDetectedByPrevious
  ).map((row) => {
    if (row[0] === detections) {
      return [
        row[0],
        row[1] === 0 ? (
          0
        ) : (
          <RedirectLink
            href={`logs?${generateRedirectUrlToLog(
              [
                {
                  field: 'threatType',
                  values: [
                    ThreatType.Phishing,
                    ThreatType.MaliciousURL,
                    ThreatType.Ransomware,
                  ],
                  type: 'terms',
                },
                {
                  field: 'securityFilterName',
                  values: [SecurityFilterName.WebReputation],
                  type: 'terms',
                },
                {
                  field: 'scanSource',
                  values: getServiceNamesByValues(
                    servicesModel.enabledServices
                  ),
                  type: 'terms',
                },
              ],
              props.day,
              LogTypeEnum.DETECTION
            )}`}
          >
            <Text>{row[1]}</Text>
          </RedirectLink>
        ),
        row[2],
        <Percent n={row[row.length - 1]} />,
      ];
    } else {
      return [...row.slice(0, -1), <Percent n={row[row.length - 1]} />];
    }
  });

  return (
    <DashboardCard title={t('dashboard.chart.title.atpWebReputation')}>
      <TableTemplate config={config} header={header} data={data} />
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskWebReputation);
